// Dependencias generales
import React from "react"
import { useEffect, useState } from 'react'
import '../../css/dashboard.css'
import MainHeaderHELIAS from '../../components/AppLayout/MainHeaderHELIAS'
import FooterHELIAS from '../../components/AppLayout/FooterHELIAS'

import Dashboard from "./Dashboard"
import Rules from "./Rules"
import HeliasAnalytics from "./HeliasAnalytics"
import Advisory from "./Advisory"
import InstallationConfiguration from './InstallationConfiguration'
import UserAccount from '../UserAccount'
import InstallationActivity from "./InstallationActivity"
import Support from '../Support'
import HistoricalEconomics from "./HistoricalEconomics.js"

var dashboardCommonJS = require("../../js/dashboardCommon.js")
var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

// DASHBOARD
const Main = (params) => {
  
  const [selectedAppOption, setSelectedAppOption] = useState("")
  const [selectedModalAppOption, setSelectedModalOption] = useState("")

  useEffect(() => {   
    
    console.log("Estructura principal de la aplicación cargada correctamente.")   

    document.documentElement.setAttribute('style','background:#2B1B76;')    
    document.querySelector('meta[name="theme-color"]').setAttribute("content", "#2B1B76;");
    
    localStorage.removeItem("installerMode")

    if(params.page === ""){ setSelectedAppOption(<Dashboard seleccionarOpcionMenu={seleccionarOpcionMenu}/>) }
    else { seleccionarOpcionMenu("opcionMenu"+params.page) }
   
  }, [])

  function gestionarVisibilidadMenuPrincipal(event){   

    if (event.target.id === "cuentaRegresivaAvatar"){      
      if (!document.documentElement.className.includes("menu-open")) { document.documentElement.className = "menu-open" }
      else {document.documentElement.className = ""}
    }
    else if(event.target.id !== "menuPrincipal") {
      if(event.target.id.includes("opcionMenu")){
        document.documentElement.className = ""    
        seleccionarOpcionMenu(event.target.id.replace("Literal",""))
      }
      else{
        document.documentElement.className = ""
      }
    }  
    
  }; 

  function operarDetalleLateralPantallaCompleta(accion){  
    if(accion === "abrir"){      
      document.getElementById("detalleLateralPantallaCompleta").className = "modal lateral-detail"      
    }else{
      document.getElementById("detalleLateralPantallaCompleta").className = "modal lateral-detail hidden"
    }    
  }

  function gestionarVisibilidadModalDetalle(event){        
    if ( (document.getElementById("detalleLateralPantallaCompleta") !== null) && !document.getElementById("detalleLateralPantallaCompleta").className.includes("hidden") && (event.target.id === "detalleLateralPantallaCompleta") ){
        operarDetalleLateralPantallaCompleta("cerrar")             
    }
  }; 

  document.addEventListener("keydown", (event) => {        
    if (event.key === 'Escape') {            
      document.documentElement.className = "" //Oculto menú principal
      dashboardCommonJS.operarDetalleLateral("cerrar") //Oculto menú detalle lateral
      dashboardCommonJS.operarMenuDispositivos("cerrar", "") //Oculto menú dispositivos
    }
  });  



  function seleccionarOpcionMenu(opcionSeleccionada){

    try{
      document.getElementById("opcionMenuInstallerDashboard").className = "button secondary list full-width"    
    }
    catch(error){/* Controlo casos en los que no se muestre la opción */}

    document.getElementById("opcionMenuDashboard").className = "button secondary list full-width"
    document.getElementById("opcionMenuRules").className = "button secondary list full-width"
    document.getElementById("opcionMenuInstallationActivity").className = "button secondary list full-width"
    document.getElementById("opcionMenuHeliasAnalytics").className = "button secondary list full-width"
    document.getElementById("opcionMenuHistoricalEconomics").className = "button secondary list full-width"
    document.getElementById("opcionMenuAdvisory").className = "button secondary list full-width"
    document.getElementById("opcionMenuInstallationConfiguration").className = "button secondary list full-width"
    document.getElementById("opcionMenuUserAccount").className = "button secondary list full-width"
    document.getElementById("opcionMenuSupport").className = "button secondary list full-width"
    document.getElementById("opcionMenuCookies").className = "button secondary list full-width"    
    document.getElementById("opcionMenuLogout").className = "button secondary list full-width"
      
    /* Opciones ocultas ya que se entuentran dentro de la navegación del dashboard */
    document.getElementById("liRules").className = document.getElementById("liRules").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("liInstallationActivity").className = document.getElementById("liInstallationActivity").className.replaceAll(" hidden", "") + " hidden"    
    document.getElementById("liHeliasAnalytics").className = document.getElementById("liHeliasAnalytics").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("liHistoricalEconomics").className = document.getElementById("liHistoricalEconomics").className.replaceAll(" hidden", "") + " hidden"
    
    if(localStorage.getItem("installationName").includes("INSTALADOR")){
      document.getElementById("liUserAccount").className = document.getElementById("liUserAccount").className.replaceAll(" hidden", "") + " hidden"    
      document.getElementById("liSupport").className = document.getElementById("liSupport").className.replaceAll(" hidden", "") + " hidden"    
      document.getElementById("liCookies").className = document.getElementById("liCookies").className.replaceAll(" hidden", "") + " hidden"    
    }

    document.getElementById("cabeceraHelias").className = document.getElementById("cabeceraHelias").className.replaceAll(" hidden", "")
    
    var tzoffset = ""
    var fechaActual = ""

    try{
      if(opcionSeleccionada !== "opcionMenuCookies"){
        document.getElementById(opcionSeleccionada).className += " current"
      }
      else{
        console.log(window.location.pathname)
        document.getElementById("opcionMenu"+window.location.pathname.replaceAll("/","")).className += " current"
      }      
    }
    catch(error){console.log(error)} //Para controlar páginas sin opción de menú tipo BillingPlans
    
    if( (opcionSeleccionada !== "opcionMenuCookies") && (opcionSeleccionada !== "opcionMenuRules") && (opcionSeleccionada !== "opcionMenuHeliasAnalytics") && (opcionSeleccionada !== "opcionMenuHistoricalEconomics") && (opcionSeleccionada !== "opcionMenuInstallationActivity") ){ 
      window.history.pushState("", "", '/'+opcionSeleccionada.replace("opcionMenu", "").replace("Helias", ""))      
    }   

    if(opcionSeleccionada === "opcionMenuDashboard"){ 
      document.title = "HELIAS - Inicio"  
      
      if(localStorage.getItem("forceDashboardRefreshOnMenuHomeClick") === null){
        tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        fechaActual = (new Date(Date.now() - tzoffset)).toISOString()
        setSelectedAppOption(<Dashboard seleccionarOpcionMenu={seleccionarOpcionMenu} update={fechaActual}/>)             
      }
      else{
        window.location.href = "/Dashboard"
        localStorage.removeItem("forceDashboardRefreshOnMenuHomeClick")
      }
      
    }    
    else if(opcionSeleccionada === "opcionMenuRules"){             
      
      if(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.MainElectricConnectionSensorsInInstallation === "true" ){ //Es un usuario con monitor        
        document.title = "HELIAS - Reglas"
        document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" hidden", "")    
        
        tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        fechaActual = (new Date(Date.now() - tzoffset)).toISOString()
        
        setSelectedModalOption(<Rules abrirNuevaRegla={"false"} operarDetalleLateralPantallaCompleta={operarDetalleLateralPantallaCompleta} update={fechaActual}/>) 
        dashboardCommonJS.precalentarLambda("putInstallationRules")                
        operarDetalleLateralPantallaCompleta("abrir")           
      }
      else{ // Es un usuario sin monitor (NOVATO)
        initialConfigCommonJS.mostrarMensajeInformativo("Para poder configurar reglas debes tener configurado un monitor de consumo.","info")
      } 
    }
    else if(opcionSeleccionada === "opcionMenuInstallationActivity"){ 
      document.title = "HELIAS - Actividad"      
      setSelectedModalOption(<InstallationActivity operarDetalleLateralPantallaCompleta={operarDetalleLateralPantallaCompleta} seleccionarOpcionMenu={seleccionarOpcionMenu}/>) 
      operarDetalleLateralPantallaCompleta("abrir")   
    }
    else if(opcionSeleccionada === "opcionMenuHeliasAnalytics"){ 
      document.title = "HELIAS - Histórico" 
      document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" hidden", "")     
      setSelectedModalOption(<HeliasAnalytics operarDetalleLateralPantallaCompleta={operarDetalleLateralPantallaCompleta} update={new Date().getTime()}/>)       
      operarDetalleLateralPantallaCompleta("abrir")   
    }
    else if(opcionSeleccionada === "opcionMenuHistoricalEconomics"){ 
      document.title = "HELIAS - Histórico económico" 
      document.getElementById("divIconoRefrescarDashboard").className = document.getElementById("divIconoRefrescarDashboard").className.replaceAll(" hidden", "")     
      setSelectedModalOption(<HistoricalEconomics operarDetalleLateralPantallaCompleta={operarDetalleLateralPantallaCompleta} />)                   
      operarDetalleLateralPantallaCompleta("abrir")     
    }
    else if(opcionSeleccionada === "opcionMenuAdvisory"){ 
      document.title = "HELIAS - Asesoramiento"
      setSelectedAppOption(<Advisory selectedOption={params.selectedOption} subOption={params.subOption}/>) }
    else if(opcionSeleccionada === "opcionMenuInstallationConfiguration"){ 
      document.title = "HELIAS - Configuración"
      setSelectedAppOption(<InstallationConfiguration selectedOption={params.selectedOption}/>) 
    }    
    else if(opcionSeleccionada === "opcionMenuUserAccount"){ 
      document.title = "HELIAS - Cuenta de usuario"
      setSelectedAppOption(<UserAccount/>) 
    }
    else if(opcionSeleccionada === "opcionMenuSupport"){ 
      document.title = "HELIAS - Ayuda y soporte"
      setSelectedAppOption(<Support/>) 
    }  
    else if(opcionSeleccionada === "opcionMenuCookies"){          
      try{        
        //document.getElementById("linkConsentimiento").click()
        generalCommonJS.mostrarPrivacidad()
      }
      catch(error){console.log(error)}
    }   
    else if(opcionSeleccionada === "opcionMenuLogout"){ 
      document.title = "HELIAS - Salir"
      window.location="/Logout"       
    }

  }

  return (    
    <main id="mainDiv" onMouseDown={gestionarVisibilidadMenuPrincipal}>      
      
      <MainHeaderHELIAS/>
      
      {selectedAppOption}      
      
      <aside id="detalleLateralPantallaCompleta" className="modal lateral-detail hidden" onMouseDown={gestionarVisibilidadModalDetalle}>

        {selectedModalAppOption}
          
      </aside>
      

      <FooterHELIAS/>     

    </main>
  )
}

export default Main